export const REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD_REQUESTED =
    'REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD_REQUESTED';
export const REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD_SUCCEEDED =
    'REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD_SUCCEEDED';
export const REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD_FAILED =
    'REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD_FAILED';

export const REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_REQUESTED =
    'REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_REQUESTED';
export const REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_SUCCEEDED =
    'REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_SUCCEEDED';
export const REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_FAILED =
    'REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_FAILED';
export const REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_CANCELED =
    'REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_CANCELED';

export const REPORTS_HARVEST_INSPECTIONS_PEOPLE_SET =
    'REPORTS_HARVEST_INSPECTIONS_PEOPLE_SET';
export const REPORTS_HARVEST_INSPECTIONS_PEOPLE_MERGE =
    'REPORTS_HARVEST_INSPECTIONS_PEOPLE_MERGE';
export const REPORTS_HARVEST_INSPECTION_SET = 'REPORTS_HARVEST_INSPECTION_SET';
